/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_Existing_LotInputs */

const vi_lot_items_existing_lot = /** @type {(inputs: Lot_Items_Existing_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô có sẵn`)
};

/**

* @param {Lot_Items_Existing_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_existing_lot = /** @type {((inputs?: Lot_Items_Existing_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Existing_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_existing_lot(inputs)
});